import React, { useEffect } from "react";
import { Redirect, matchPath, useLocation } from "react-router-dom";

export function PageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = pathname.split("/").filter(Boolean).pop();
    const label = page === "dashboard" ? "Paneli" : page;
    document.title = label ? `acctree | ${label}` : "acctree";
  }, [pathname]);
  return null;
}

// Preserve existing route matching; redirect only when none of the pages match.
function matchesPage(children, pathname) {
  return React.Children.toArray(children).some(child => {
    if (!React.isValidElement(child)) return false;
    if (child.props.path) return Boolean(matchPath(pathname, child.props));
    return matchesPage(child.props.children, pathname);
  });
}

export function AuthenticatedPages({ children, ready = true }) {
  const { pathname } = useLocation();
  if (matchesPage(children, pathname) || (!ready && pathname !== "/")) return <>{children}</>;
  return <Redirect to="/dashboard" />;
}
